import { useState, useMemo, useEffect, useRef } from 'react';
import '../../../assets/css/StudentDashboard.css'
import { getBlob, getData } from '../../../API/GlobalApi.js';
import { handlePaginate } from '../../../Utils/handlePagination.js';
import SearchingBar from '../../../Utils/Searching.js';
import Notifier from '../../../Utils/notify.js';
import AdvanceTable from '../../../Utils/AdvanceTables.js';
import TableSkeleton from '../../../Utils/TableSkeleton.js';
import exporticon from '../../../assets/icons/export-data.svg';
import ProfileStatus from '../../../Component/ProfileStatus.js';
import debit from '../../../assets/icons/rupee-line-circle-svgrepo-com.svg'
import { highlightMatch } from '../../../Utils/highlightSearchFunctions.js';
import { reactSelectStyles } from '../../../Utils/selectBoxStyle.js';
import Select from 'react-select'
import SpinnerLoader from '../../../Utils/Spinner.js';
import TableLoaderOverlay from '../../../Utils/tableFadingLoader.js';
import { useTableFade } from '../../../Utils/tableFadeHooks.js';
const FeeDueReport = () => {

    // const skipSpinnerRef = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isSearchLoading, setSearchLoading] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [studentsAcademicFeeData, setstudentsAcademicFeeData] = useState([])
    const [selectedStudentAcademicFeeData, setselectedStudentAcademicFeeData] = useState([]);
    const [filterStudent, setfilterStudent] = useState([])
    const pageSize = 10;
    const pageCounts = Math.ceil(totalCount / pageSize);
    const [filterQueryString, setFilterQueryString] = useState({});

    const [filterLoading, setFilterLoading] = useState(false);

    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);
    const [isFilterApplied, setIsFilterApplied] = useState(false);

    const [paymentStats, setPaymentStats] = useState({ total_due_amount: 0 });

    const getStudentAcademicFeeReports = async (page = 0, field = sortField, order = sortOrder, query = filterQueryString) => {
        const pageNumber = page + 1;
        const params = new URLSearchParams(query);
        params.set("page", pageNumber);
        if (field) params.set("type", field);
        if (order) params.set("sort_by", order);
        const url = `academics/students/finance/all/?${params.toString()}`;

        if (!skipSpinnerRef.current) {
            if (isInitialLoad) setIsLoading(true);
            else setSearchLoading(true);
        }
        try {
            const response = await getData(url);
            setstudentsAcademicFeeData(response?.results);
            setfilterStudent(response?.results)
            setPaymentStats({ total_due_amount: response?.total_due_amount || 0 });

            setTotalCount(response?.count);
        } catch (error) {
            Notifier.error(error)
            setstudentsAcademicFeeData([]);
            setTotalCount(0);
        } finally {
            if (!skipSpinnerRef.current) {
                if (isInitialLoad) {
                    setIsLoading(false);
                    setIsInitialLoad(false);
                } else {
                    setSearchLoading(false);
                }
            }

            // ✅ Always reset after fetch
            setFilterLoading(false);
            skipSpinnerRef.current = false;
        }
    };


    const currentPageRef = useRef(currentPage);

    // useEffect(() => {
    //     currentPageRef.current = currentPage;
    //     getStudentAcademicFeeReports(currentPage);
    // }, [currentPage, filterQueryString]);


    useEffect(() => {

        getStudentAcademicFeeReports(currentPage)
            .finally(() => stopTableLoading()); // hide fade overlay
    }, [currentPage, filterQueryString]);



    const handlePageChange = ({ selected }) => {
        triggerTableLoading();     // show fade overlay
        setCurrentPage(selected);  // only update page
    };



    // const handleSort = (field, order) => {
    //     setSortField(field);
    //     setSortOrder(order);
    //     setCurrentPage(0);
    //     setIsFilterApplied(false);
    //     setfilterStudent([]);
    //     const queryParams = new URLSearchParams(filterQueryString || "");
    //     queryParams.set("type", field);
    //     queryParams.set("sort_by", order);
    //     // const newQuery = queryParams.toString();
    //     // setFilterQueryString(newQuery);
    //     setFilterQueryString((prev) => ({
    //         ...prev,
    //         type: field,
    //         sort_by: order,
    //     }));

    //     // Fetch first page with new sort
    //     getStudentAcademicFeeReports(0, field, order, newQuery);
    // };

    const handleSort = (field, order) => {
        setSortField(field);
        setSortOrder(order);
        setCurrentPage(0);
        setIsFilterApplied(false);
        setfilterStudent([]);

        // Always keep filterQueryString as OBJECT
        setFilterQueryString((prev) => ({
            ...prev,
            type: field,
            sort_by: order,
        }));

        // Fetch first page with updated filters
        getStudentAcademicFeeReports(0, field, order, {
            ...filterQueryString,
            type: field,
            sort_by: order,
        });
    };


    const handleRowClick = async (userId, row) => {
        try {
            setselectedStudentAcademicFeeData(row?.original)
        } catch (error) {
        }
    };


    const sourceData = useMemo(() => {
        // return filterQueryString ? filterStudent : studentsAcademicFeeData;
        if (isFilterApplied && filterStudent?.length > 0) {
            return filterStudent;
        }
        return studentsAcademicFeeData;
    }, [studentsAcademicFeeData, filterStudent, isFilterApplied]);

    const formattedData = useMemo(() => {
        return sourceData?.map((std) => ({
            id: std.mobile,
            name: std.student_name,
            course: std.course,
            mobile: std.mobile,
            registration_number: std.registration_number,
            total_imposed_fee: std.total_imposed_fee,
            total_scheduled_fee: std.total_scheduled_fee,
            total_ledger_credit: std.total_ledger_credit,
            balance: std.total_due,
            total_ledger_credit: std.total_ledger_credit,
            handleRowClick, // for table row action
        }));
    }, [sourceData]);


    const searchValue = new URLSearchParams(filterQueryString).get("search") || "";


    const searchInputRef = useRef(null);
    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, []);


    const columns = useMemo(
        () => [

            {
                Header: "Student Name",
                accessor: 'name',
                disableSortBy: false,
                Cell: ({ row }) => (
                    <div
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleRowClick(row.original.id, row)}                     >
                        {/* <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>
                            {row.original.name}
                        </p> */}
                        <p
                            style={{
                                textAlign: "left",
                                color: "#222F3E",
                                fontWeight: 500,
                                margin: 0,
                            }}
                            dangerouslySetInnerHTML={{
                                __html: highlightMatch(
                                    row.original.name?.toString() || "-",
                                    searchValue
                                ),
                            }}
                        />

                    </div>
                ),
            },
            {
                Header: () => <p style={{ textAlign: 'left' }}>Course</p>,
                accessor: 'course',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div className="no-text-cursor" >
                        <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>{row.original.course}</p>
                    </div>
                )
            },



            {
                Header: () => <p style={{ textAlign: 'left' }}>Registration No.</p>,
                accessor: 'registration_number',
                disableSortBy: true,
                Cell: ({ row }) => (
                    // <div style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>
                    //     {row.original.registration_number}
                    // </div>
                    <p className="no-text-cursor"
                        style={{
                            textAlign: "left",
                            color: "#222F3E",
                            fontWeight: 500,
                            margin: 0,
                        }}
                        dangerouslySetInnerHTML={{
                            __html: highlightMatch(
                                row.original.registration_number?.toString() || "-",
                                searchValue
                            ),
                        }}
                    />
                )
            },

            {
                Header: () => <p style={{ textAlign: 'left' }}>Contacts</p>,
                accessor: 'mobile',
                disableSortBy: true,
                Cell: ({ row }) => (
                    // <div style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>
                    //     {row.original.mobile}
                    // </div>
                    <p className="no-text-cursor"
                        style={{
                            textAlign: "left",
                            color: "#222F3E",
                            fontWeight: 500,
                            margin: 0,
                        }}
                        dangerouslySetInnerHTML={{
                            __html: highlightMatch(
                                row.original.mobile?.toString() || "-",
                                searchValue
                            ),
                        }}
                    />
                )
            },
            {
                Header: () => <p style={{ textAlign: 'right' }}>Scheduled/Due Fee</p>,
                accessor: "total_scheduled_fee",
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div style={{ textAlign: 'right', color: '#222F3E', margin: 0 }} className="no-text-cursor">
                        ₹ {row.original.total_scheduled_fee?.toFixed(2)}
                    </div>
                )
            },
            {
                Header: () => <p style={{ textAlign: 'right' }}>Total amount paid</p>,
                accessor: 'total_ledger_credit',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div style={{ textAlign: 'right', color: '#222F3E', margin: 0 }} className="no-text-cursor">

                        ₹ {row.original.total_ledger_credit?.toFixed(2)}
                    </div>
                )
            },
            {
                Header: () => <p style={{ textAlign: 'right' }}>Balance</p>,
                accessor: "balance",
                disableSortBy: false,
                headerJustify: "end",
                Cell: ({ row }) => {
                    const scheduled = row.original.total_scheduled_fee ?? 0;
                    const paid = row.original.total_ledger_credit ?? 0;
                    const due = scheduled - paid;

                    // Color rule
                    const color = due < 0 ? "green" : "red";

                    return (
                        <div style={{ textAlign: 'right', color, margin: 0 }} className="no-text-cursor">
                            ₹ {Math.abs(due).toFixed(2)}
                        </div>
                    );
                }
            }
        ],
        [searchValue]
    );


    const handleSetSearchResults = (data) => {
        setfilterStudent(Array.isArray(data) ? data : []);
    };

    // const handlePageChange = ({ selected }) => {
    //     setCurrentPage(selected);
    //     // handlePaginate({
    //     //     selectedPage: selected,
    //     //     url: 'academics/students/finance/all/',
    //     //     filterQueryString,
    //     //     setResults: handleSetSearchResults,
    //     //     setTotalCount,
    //     //     setFilterQueryString,
    //     // });
    // }

    const { skipSpinnerRef, tableLoading, triggerTableLoading, stopTableLoading } = useTableFade();

    const handleExportExcel = async () => {
        try {
            const queryToSend = { ...filterQueryString };
            delete queryToSend.page;
            const params = new URLSearchParams(queryToSend);
            const urlWithParams = `academics/students/finance/export/?${params.toString()}`;

            const blob = await getBlob(urlWithParams);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "students_fee_due_report.xlsx";
            document.body.appendChild(a);
            a.click();
            a.remove();
            Notifier.success("Excel exported successfully");
        } catch (error) {
            Notifier.error("❌ Excel export failed");
        }
    };



    const [courseOptions, setCourseOptions] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(null);



    const getCourses = async () => {
        try {
            const response = await getData("academics/unpaginated-courses/");
            console.log("response of courses", response);

            if (response?.data?.length) {
                const formatted = response.data.map((item) => ({
                    label: item,
                    value: item,
                }));
                setCourseOptions(formatted);
            }
        } catch (error) {
            Notifier.error("Couse getting errors")
            console.error("Error fetching courses:", error);

            // Optional — show toast
            // Notifier.error("Failed to load courses!");

            // Clear list to avoid stale data
            setCourseOptions([]);
        }
    };


    useEffect(() => {
        getCourses();
    }, []);

    const handleCourseChange = async (course) => {
        setSelectedCourse(course);
        setFilterQueryString((prev) => ({
            ...prev,
            alias: course?.value || "",
        }));
        setCurrentPage(0);
        // ✅ Show only table spinner

        skipSpinnerRef.current = true;  // only table spinner
        setFilterLoading(true);

    };


    return (
        <>
            {isLoading ? (
                <TableSkeleton rows={10} columns={6} showHeader={true} />
            ) :
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100vh",
                    overflow: "hidden",
                    position: "relative",
                }}>

                    {/* ── FIXED: Title + Stats Card ── */}
                    <div style={{ flexShrink: 0, padding: "0 12px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <h2 className="main-heading">Fee Due – Report ({totalCount})</h2>
                            <ProfileStatus
                                label="Total Due Amount" icon={debit}
                                iconColor="red" bgColor="#FDE2E2" circleColor="#39886F"
                                amountsData={Number(paymentStats.total_due_amount || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                height="60px" widths="300px"
                            />
                        </div>
                    </div>

                    {/* ── FIXED: Search + Filters ── */}
                    <div style={{ flexShrink: 0, padding: "8px 12px" }}>
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", alignItems: "center" }}>
                            <SearchingBar
                                placeholder="Search by Student name, Registration No., Contact No. ...."
                                url="/academics/students/finance/all/"
                                filterQueryString={filterQueryString}
                                setResults={handleSetSearchResults}
                                ref={searchInputRef}
                                setTotalCount={setTotalCount}
                                setFilterQueryString={setFilterQueryString}
                                setSearchLoading={setSearchLoading}
                                setCurrentPage={setCurrentPage}
                            />
                            <div style={{ width: "200px" }}>
                                <Select
                                    options={courseOptions}
                                    value={selectedCourse}
                                    onChange={handleCourseChange}
                                    placeholder="Select Course"
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    isClearable
                                    styles={{
                                        ...reactSelectStyles,
                                        control: (base, state) => ({
                                            ...reactSelectStyles.control?.(base, state),
                                            minHeight: "34px",
                                        }),
                                    }}
                                />
                            </div>
                            <button
                                className="filter-btn"
                                style={{ background: "white", border: "1px solid black", height: "35px" }}
                                title="Export Data"
                                onClick={handleExportExcel}
                            >
                                <img src={exporticon} alt="Export" />
                            </button>
                        </div>
                    </div>

                    {/* ── SCROLLABLE: Table only ── */}
                    <div style={{
                        flex: 1,
                        minHeight: 0,
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                        padding: "0 12px",
                        position: "relative",
                    }}>
                        {filterLoading ? (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1 }}>
                                <SpinnerLoader />
                            </div>
                        ) : formattedData?.length > 0 ? (
                            <>
                                <AdvanceTable
                                    columns={columns}
                                    pageCounts={pageCounts}
                                    handlePageChange={handlePageChange}
                                    selectedData={selectedStudentAcademicFeeData}
                                    data={formattedData}
                                    handleRowClick={handleRowClick}
                                    currentPage={currentPage}
                                    checkbox={false}
                                    handleSort={handleSort}
                                    sortField={sortField}
                                    sortOrder={sortOrder}
                                />
                                <TableLoaderOverlay isLoading={tableLoading} />
                            </>
                        ) : (!isLoading && !isSearchLoading && (
                            <div style={{
                                display: "flex", flexDirection: "column",
                                alignItems: "center", justifyContent: "center",
                                flex: 1, color: "#888", textAlign: "center",
                            }}>
                                No Student's Fee report.
                            </div>
                        ))}
                    </div>
                </div>
            }


        </>
    );
};


export default FeeDueReport